// extracted by mini-css-extract-plugin
export default {"contentWrapper":"about_contentWrapper__DkX3s","imageWrapper":"about_imageWrapper__NJIZb","text":"about_text__xznoL"};